import {h, Fragment} from "preact"
import { slugify } from '../../../utils'

export default function Checkbox({ value, selected, onChange, className }) {
    return (
        <>
            <input class={`checkbox-custom ${className}`} type="checkbox" checked={selected} onChange={onChange} id={`checkbox-${slugify(value)}`} />
                <label class="flex checkbox-custom-label" for={`checkbox-${slugify(value)}`}><div>
                    <span class="txt">{value}</span>
                </div>
            </label>
        </>
    )
}